var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fields-patternText',{attrs:{"spec":_vm.spec,"type":"datetime-local","pattern":"[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}","value":_vm.value}})}
var staticRenderFns = []

export { render, staticRenderFns }